// extracted by mini-css-extract-plugin
export default {"rewardSuspension":"rewardSuspension___VkeBB"};